import { IconButton, TextField } from '@material-ui/core';
import { Search } from '@material-ui/icons';
import GridItem from 'components/Grid/GridItem';
import React from 'react';
export default function FilterBusinessPartner({ value, getValue, getData }) {
  const handleChange = (e) => {
    getValue({ ...value, [e.target.name]: e.target.value });
  };

  const enter = (e) => {
    if (e.charCode == 13) getData(value);
  };

  return (
    <>
      <GridItem xs={12} lg={3}>
        <TextField
          placeholder="Código"
          fullWidth
          margin="normal"
          name="CardCode"
          defaultValue=""
          onChange={handleChange}
          onKeyPress={enter}
          InputProps={{
            endAdornment: (
              <IconButton aria-label="buscar" style={{ padding: 4 }} onClick={getData}>
                <Search color="inherit" />
              </IconButton>
            ),
          }}
        />
      </GridItem>
      <GridItem xs={12} lg={3}>
        <TextField
          placeholder="Nombre (min 4 dígitos...)"
          fullWidth
          margin="normal"
          name="CardName"
          defaultValue=""
          onChange={handleChange}
          onKeyPress={enter}
          InputProps={{
            endAdornment: (
              <IconButton aria-label="buscar" style={{ padding: 4 }} onClick={getData}>
                <Search color="inherit" />
              </IconButton>
            ),
          }}
        />
      </GridItem>
      <GridItem xs={12} lg={3}>
      <TextField
          placeholder="RUC / DNI"
          fullWidth
          margin="normal"
          name="LicTradNum"
          defaultValue=""
          onChange={handleChange}
          onKeyPress={enter}
          InputProps={{
            endAdornment: (
              <IconButton aria-label="buscar" style={{ padding: 4 }} onClick={getData}>
                <Search color="inherit" />
              </IconButton>
            ),
          }}
        />
      </GridItem>
    </>
  );
}
